import { dashboardTableSelectTriggerClassName } from '@shigo-ui/dashboard-ui';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';

enum CampaignBrandFilterValue {
  AllBrands = 'ALL_BRANDS',
}

export type CampaignBrandFilter = {
  brandId: string;
  options: readonly { id: string; name: string }[];
  loading: boolean;
  onChange: (brandId: string) => void;
};

/** Narrows the campaigns table to one brand, or all brands. */
export function CampaignBrandSelect({ brandId, options, loading, onChange }: CampaignBrandFilter) {
  return (
    <Select
      value={brandId || CampaignBrandFilterValue.AllBrands}
      disabled={loading}
      onValueChange={(value) => {
        onChange(isAllCampaignBrandsFilter(value) ? '' : value);
      }}
    >
      <SelectTrigger
        className={dashboardTableSelectTriggerClassName('w-48')}
        aria-label={dashboardT('campaigns.brandFilter')}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={CampaignBrandFilterValue.AllBrands}>
          {dashboardT('campaigns.allBrands')}
        </SelectItem>
        {options.map((brand) => (
          <SelectItem key={brand.id} value={brand.id}>
            {brand.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

function isAllCampaignBrandsFilter(value: string) {
  const allBrandsValue: string = CampaignBrandFilterValue.AllBrands;
  return value === allBrandsValue;
}
